import { GridColDef } from '@mui/x-data-grid-premium';
import { currencyCell } from 'components/cells';
import DataGridCell from 'components/cells/DataGridCell';
import { createColumns } from 'components/enhanced/data-grid/utils';
import { useTranslation } from 'react-i18next';
import { IRoleName } from './types';

export function RoleColumns(): GridColDef[] {
  const { t } = useTranslation();
  return createColumns<IRoleName>(
    [
      {
        field: 'role',
        headerName: t(`global.role`),
        minWidth: 150
      },
      {
        field: 'role_name',
        minWidth: 150
      },
      {
        field: 'fte',
        type: 'number',
        minWidth: 150
      },
      {
        field: 'monthly_hours',
        type: 'number',
        minWidth: 150,
        renderCell: (params) => (
          <DataGridCell
            content={((+params.row.monthly_hours).toFixed(2) as string).replace('.', ',')}
          />
        )
      },
      {
        field: 'monthly_cost',
        type: 'number',
        flex: 1,
        renderCell: currencyCell
      }
    ],
    t,
    `entities.expertise`
  );
}
